<template lang="pug">
j-confirm-dialog(
  :showDialog="visible"
  :messages="state.messages"
  :cancel-text="state.button.no"
  :ok-text="state.button.yes"
  :color-confirm="state.isCritical ? 'red' : 'primary'"
  @on-cancel="handleAction('close')"
  @on-close="handleAction('close')"
  @on-ok="handleAction('confirm')"
)
</template>

<script>
import { defineComponent, getCurrentInstance, ref, reactive } from 'vue'
import { JConfirmDialog } from '@/components'

const AppConfirm = defineComponent({
  components: {
    JConfirmDialog
  },
  setup(props, { emit, expose }) {
    const { $root } = getCurrentInstance().proxy

    const visible = ref(false)
    const createDefaultState = () => ({
      title: $root.$t('common.confirm'),
      messages: [],
      isCritical: false,
      button: { yes: $root.$t('common.yes'), no: $root.$t('common.no') },
      onConfirm: null,
      onClose: null
    })
    const state = reactive(createDefaultState())

    const open = (options) => {
      Object.assign(state, createDefaultState())
      Object.assign(state, options)
      visible.value = true
    }

    const handleAction = (type) => {
      visible.value = false
      if (type === 'confirm' && state.onConfirm) state.onConfirm()
      if (type === 'close' && state.onClose) state.onClose()
    }

    expose({ open })

    return {
      visible,
      state,
      handleAction,
      open
    }
  }
})
export default AppConfirm
</script>
